const CheckIcon = ({
    className,
    color = "var(--green-3)"
}) => {
    return (
        <svg 
            className={className} 
            width="22" height="22" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg">
            <path d="M20.7 6.3C20.3 5.9 19.7 5.9 19.3 6.3L9 16.6L4.7 12.3C4.3 11.9 3.7 11.9 3.3 12.3C2.9 12.7 2.9 13.3 3.3 13.7L8.3 18.7C8.5 18.9 8.7 19 9 19C9.3 19 9.5 18.9 9.7 18.7L20.7 7.7C21.1 7.3 21.1 6.7 20.7 6.3Z" fill={color}/>
        </svg>
    );
}

export default CheckIcon;